import {
  IconBrandEmail,
  IconFacebook,
  IconInstagram,
  IconPinterest,
  IconTiktok,
  IconYoutube,
  IconX,
} from "@tvg/fuse/icon/all";
import React from "react";

export const EmailIcon: React.FC = IconBrandEmail;
export const FacebookIcon: React.FC = IconFacebook;
export const InstagramIcon: React.FC = IconInstagram;
export const PinterestIcon: React.FC = IconPinterest;
export const TiktokIcon: React.FC = IconTiktok;
export const XIcon: React.FC = IconX;
export const YoutubeIcon: React.FC = IconYoutube;
